module.exports = __webpack_public_path__ + "static/media/client-friso.a5ee5ac6.png";